module.exports = __webpack_public_path__ + "static/media/money-spec.2442e1ed.png";